import { PageSourceType } from "../page/models";
import clsx from "clsx";

const SourceTypes: string[] = ["Table", "Query"];
export const SelectSourceType = ({ title, value, className, onChange }: {
    title: string,
    value?: PageSourceType,
    className?: string,
    onChange: (value: PageSourceType) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as PageSourceType;
        onChange(newValue);
    }

    return (
        <div className={clsx(className, "field-group")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm">
                <option></option>
                {SourceTypes.map(type =>
                    <option key={type} value={type}>{type}</option>)}
            </select>
        </div>
    )
}